import React from "react"
import AppDialog from "../../../components/Common/AppDialog"

import '../order.css';

const DeliverOrder = (props) => {

    return (
        <AppDialog
            open={props.open}
            close={() => props.close()}
            title={'Mark as delivered'}
            titleIcon={'complete'}
            positiveTitle={'Confirm delivery'}
            positivePress={() => props.submit()}
            negativePress={() => props.close()}
            negativeTitle={'Cancel'}
            width={'40%'}
        >
            <div className="">
            Are you sure you want to confirm delivery for this order? Once confirmed, the order status will be updated to “Delivered”.
            <ul className="mt-2" style={{color: '#686868'}}>
                <li>Please ensure the customer has received the package in good condition before proceeding.</li>
                <li>The system will start the countdown for order auto-closure if there are no refund or replacement requests.</li>
            </ul>
            </div>
        </AppDialog>
    )
}

export default DeliverOrder;